import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'

// import locale from 'element-ui/lib/locale/lang/en'
import App from './App'
import router from './router'
import store from './store' //vuex数据
import '@/icons' // icon
import '@/permission' // 权限
import common from './common_js/common' //公共JS函数文件
import hoverEditor from './directives/hover-editor' // 悬浮编辑图标指令
import QnImage from '@/components/QnImage'
import QnUploadT from '@/components/QnUpload-1.0.0'
import QnInput from '@/components/QnInput'
import $ from 'jquery'

Vue.component('qn-image', QnImage)
Vue.component('qn-upload-t', QnUploadT)
Vue.component('qn-input', QnInput)

Vue.use(common);

// 注册全局自定义指令
Vue.directive('hover-editor', hoverEditor)



import axios from 'axios'
Vue.prototype.axios = axios
//Vue.use(addressPicker);//导入会有错

Vue.use(ElementUI)
Vue.config.productionTip = false
import env from './env.js' //just run

Vue.prototype.$bus = new Vue();
window.eventBus = new Vue();
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js